export default {
  title: 'Busy mode',
  form: {
    has_busy_mode: {
      label: 'Busy mode',
    },
    busy_mode_minutes: {
      label: 'How much time to add to your regular preparation time?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 hour',
      },
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes saved successfully',
  },
};
